import React from 'react';
import { routePaths } from 'components/Routes/data';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { PendingApproval } from './PendingApproval';
import { InitiatedByMe } from './InitiatedByMe';
import { Completed } from './Completed';

const FinalizePayroll = () => {
  const location = useLocation();
  const pathname = location.pathname;

  if (pathname === routePaths.approvalWorkflows.myRequests.finalizePayroll.root) {
    return (
      <Redirect to={routePaths.approvalWorkflows.myRequests.finalizePayroll.pendingApprovals} />
    );
  }

  return (
    <Switch>
      <Route path={routePaths.approvalWorkflows.myRequests.finalizePayroll.pendingApprovals} exact>
        <PendingApproval />
      </Route>
      <Route path={routePaths.approvalWorkflows.myRequests.finalizePayroll.initiatedByMe} exact>
        <InitiatedByMe />
      </Route>
      <Route path={routePaths.approvalWorkflows.myRequests.finalizePayroll.completed} exact>
        <Completed />
      </Route>
    </Switch>
  );
};

export { FinalizePayroll };
